import { useReviewPopup } from '@context/reviewPopupProvider';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react';
import React, { useEffect, useRef } from 'react';

/** The published App Market listing, which may differ from the app this environment runs as. */
const APP_ID = process.env.NEXT_PUBLIC_APP_ID;

const ReviewPopup: React.FC = () => {
	const { isOpen, notifyAppOpened, markReviewed, close } = useReviewPopup();
	const iframeRef = useRef<HTMLIFrameElement>(null);

	useEffect(() => {
		notifyAppOpened();
	}, [notifyAppOpened]);

	/**
	 * Wix tells the app nothing about a posted review, so the owner reaching into the review form
	 * (focus moving into its cross-origin iframe) is taken as "reviewed".
	 */
	useEffect(() => {
		if (!isOpen) {
			return;
		}

		const handleWindowBlur = () => {
			if (iframeRef.current && document.activeElement === iframeRef.current) {
				markReviewed();
			}
		};

		window.addEventListener('blur', handleWindowBlur);

		return () => window.removeEventListener('blur', handleWindowBlur);
	}, [isOpen, markReviewed]);

	return (
		<Modal size='3xl' isOpen={isOpen} onClose={close}>
			<ModalContent>
				{(onClose) => (
					<>
						<ModalHeader>Leave a Review</ModalHeader>
						<ModalBody>
							<iframe
								ref={iframeRef}
								src={`https://www.wix.com/app-market/add-review/${APP_ID}?origin=editorSdk`}
								height='560px'
								width='100%'
								style={{ border: 0 }}
								title='Wix App Market Review Submission'
							/>
						</ModalBody>
						<ModalFooter>
							<Button variant='light' onPress={onClose}>
								Close
							</Button>
						</ModalFooter>
					</>
				)}
			</ModalContent>
		</Modal>
	);
};

export default ReviewPopup;
